export const solutionsMap = {
  backup: {
    title: 'Software Backups',
    description:
      'All active backups must be removed, and Codekeeper’s access to your source code management platforms must be revoked.',
    emptyDescription:
      'Automatically backs up your source code and software assets, giving you a secure recovery option if data is deleted, corrupted, or lost.',
    buttonLink: '/backups',
    buttonText: 'Go to Software Backups',
    activeLabel: 'Backups',
    activeColor: 'text-accent-software-backup',
  },
  softwareEscrow: {
    title: 'Software Escrows',
    description:
      'All escrows must be legally terminated and the required notice period observed. Once terminated, Codekeeper’s access to your source code management platforms must be revoked.',
    emptyDescription:
      'Independently safeguards your source code and on-prem application materials, ensuring your customers can continue operations if you can no longer support the software.',
    buttonLink: '/software-escrows',
    buttonText: 'Go to Software Escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-software-escrow',
  },
  saasEscrow: {
    title: 'SaaS Escrows',
    description:
      'All escrows must be legally terminated and the required notice period observed. Once terminated, Codekeeper’s access to your source code management platforms must be revoked.',
    emptyDescription:
      'Protects your SaaS application by securing the code, infrastructure, and deployment assets needed for your customers to continue operations if your business is disrupted.',
    buttonLink: '/saas-escrows',
    buttonText: 'Go to SaaS Escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-saas-escrow',
  },
  continuity: {
    title: 'Continuity Escrows',
    description:
      'All escrows must be legally terminated and the required notice period observed. Once terminated, Codekeeper’s access to your provider accounts must be revoked.',
    emptyDescription:
      'Provides continuity protection for cloud-native applications by covering critical vendor payments if a supplier goes down, keeping services running until payments can be resumed.',
    buttonLink: '/continuity-escrows',
    buttonText: 'Go to Continuity Escrows',
    activeLabel: 'Escrows',
    activeColor: 'text-accent-continuity-escrow',
  },
  custodian: {
    title: 'Software Custodian',
    description:
      'All custodian profiles must be terminated, and Codekeeper’s access to your providers must be revoked.',
    emptyDescription:
      'End-to-end accountability for the entire software life cycle. As custodian we handle data operations in catastrophic situations where you or vendors can’t.',
    buttonText: 'Go to Custodian Profiles',
    buttonLink: '/custodian-profiles',
    activeLabel: 'Profiles',
    activeColor: 'text-accent-software-custodian',
  },
};
